/**
 * This tooltip is different than the pre-themed version that comes from
 * @radix-ui/themes. We use a custom tooltip on the app sidebar where we need
 * more control over the styling. It should only be used within the context of a
 * sidebar in its collapsed state.
 */

import {
  Tooltip as RadixTooltip,
  TooltipTrigger as RadixTooltipTrigger,
  TooltipContent as RadixTooltipContent,
  TooltipProvider as RadixTooltipProvider,
} from "@radix-ui/react-tooltip";
import cx from "classnames";
import { forwardRef } from "react";

export const TooltipProvider = RadixTooltipProvider;
export const Tooltip = RadixTooltip;
export const TooltipTrigger = RadixTooltipTrigger;

export const TooltipContent = forwardRef<
  React.ElementRef<typeof RadixTooltipContent>,
  React.ComponentPropsWithoutRef<typeof RadixTooltipContent>
>(function SidebarTooltipContent(props, ref) {
  const { className, ...rest } = props;
  return (
    <RadixTooltipContent
      ref={ref}
      className={cx(
        // This label sits ON TOP of its trigger: the collapsed sidebar buttons
        // render it with a `-ml-10` pull (see SidebarMenuButton) so the label's
        // icon lands over the button's icon while the text protrudes to the
        // right past the icon-only button. The box is `z-[9999]` and pointer
        // events are intentionally LEFT ON (interactive) so the WHOLE pill —
        // including the protruding text — is clickable. SidebarMenuButton wires
        // an `onClick` on the content that forwards the press to the underlying
        // trigger, so clicking anywhere on the label does exactly what the
        // button does. (It was briefly `pointer-events-none` to stop it
        // swallowing the button's click, but that left the protruding text
        // inert — clicks there fell through to empty space. Forwarding the click
        // is the correct fix; the reveal still keys off the tooltip's open
        // `data-state`, which holds regardless of pointer-events.)
        "group/menu-item-tooltip puntt-link z-[9999] overflow-hidden rounded-md bg-puntt-neutral-gray-4 px-3 py-2 shadow-md",
        className,
      )}
      {...rest}
    />
  );
});
